import { useEffect } from "react";
import usePagination from "./usePagination";
import { indexProjects } from "../api/main/projects";
import { IProject, IProjectIndexParams } from "../models/Project";

const useProjects = ({
    package_id,
    pageSize: defaultPageSize
}: IProjectIndexParams): ReturnType<typeof usePagination<IProject>> => {

    const hookProjects = usePagination<IProject>({ pageSize: defaultPageSize });
    const { page, pageSize } = hookProjects;

    useEffect(() => {
        const getProjects = async () => {
            hookProjects.loadingStart();
            const { data, totalItems } = await indexProjects({
                package_id,
            });
            hookProjects.setData(data);
            hookProjects.setTotalItems(totalItems)
            hookProjects.loadingEnd();
        }
        getProjects();
    }, [page, pageSize, package_id]);

    return hookProjects;
}

export default useProjects;